import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { SCREEN_TYPE } from "helpers/utils";
import SvgMirs from "components/presentation/SvgMirs";


export function ScoreContainer(props) {
  const { resultObj, screen } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const result = resultObj?.result;

  const winingDecision = resultObj?.extra?.resCode
  const winnerSchedule = resultObj?.wlt === 'W' && <div className='score-winner'><SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' /></div>
  const winner = <div className="col score-result">{resultObj?.extra?.resCode}</div>
  const isWinner = resultObj?.wlt === 'W'
  let resultDiv
  if (screen === SCREEN_TYPE.SCHEDULE) {
    resultDiv = <div className={`col score-result ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'} p-0 text-end `}>
      {winnerSchedule} &nbsp;&nbsp;{screen === SCREEN_TYPE.SCHEDULE ? result : SCREEN_TYPE.BRACKETS ? result : ''}
    </div>

  }
  else {
    resultDiv = <div className={`col score-result d-flex ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'} p-0 text-end `} style={{ width: 'max-content' }}>
      {isWinner ? <SportCode discipline={mirs_discipline} code={winingDecision} entity="@ResultCode" abbr={true} /> : ''} &nbsp;&nbsp;{screen === SCREEN_TYPE.SCHEDULE ? result : SCREEN_TYPE.BRACKETS ? result : ''}
    </div>
  }
  return (
    <div className='score-result-container d-flex justify-content-end align-self-center '>
      {resultDiv}
      {resultObj?.irm && screen !== SCREEN_TYPE.SCHEDULE &&
        <div className={`p-0 fw-bold text-end `}>
          &nbsp;<SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
        </div>
      }
    </div>
  )
}
